module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "appList"
    }
  }, [_c('com-loading'), _vm._v(" "), _c('com-header'), _vm._v(" "), _c('div', {
    staticClass: "main floatBotOuter"
  }, [_vm._l((_vm.sortProjects), function(projectObj) {
    return _c('div', {
      key: projectObj.projectId,
      staticClass: "floatBox",
      on: {
        "click": function($event) {
          return _vm.toProject(projectObj)
        }
      }
    }, [_c('p', [_vm._v(_vm._s(projectObj.projectName))]), _vm._v(" "), _c('div', {
      staticClass: "count"
    }, [_vm._v(_vm._s(projectObj.monthCount) + "/" + _vm._s(projectObj.totalCount))]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-times deleteBtn",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.showDelteModal(projectObj.projectId)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa startBtn",
      class: {
        'fa-star-o': !projectObj.hasOwnProperty('star') || !projectObj.star, 'fa-star': projectObj.hasOwnProperty('star') && projectObj.star
      },
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleStar(projectObj.projectId)
        }
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "project floatBox",
    on: {
      "click": _vm.showNewProjectInput
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 2), _vm._v(" "), _c('com-modal', {
    attrs: {
      "modalType": "input",
      "modalId": "newProjectInputModal",
      "title": "請輸入歌曲名稱",
      "ok-title": "新建",
      "emptyInputAlert": "歌曲名稱請勿空白"
    },
    on: {
      "confirm": _vm.createNewProject
    }
  }), _vm._v(" "), _c('com-modal', {
    attrs: {
      "modalType": "confirm",
      "modalId": "deleteConfirmModal",
      "title": "確認刪除此歌曲? (已上傳樂譜將同步刪除)"
    },
    on: {
      "confirm": _vm.deleteProject
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-88cea6e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-list.vue
// module id = 195
// module chunks = 2